import { Auth } from './pages/Auth/page/Auth';
import { BrowserRouter as Router, Navigate, Route, Routes } from 'react-router-dom';
import { Payments } from './pages/Trader/Payments/page/Payments';
import React, { useEffect } from 'react';
import { ProtectedRouter } from './utils/services/ProtectedRouter';
import { ServerError } from './pages/Trader/Errors/ServerError';
import { ForbiddenError } from './pages/Trader/Errors/ForbiddenError';
import { NotFoundError } from './pages/Trader/Errors/NotFoundError';
import {
  APPLICATIONS,
  AUTH,
  CARDS,
  FORBIDDEN_ERROR,
  PAYMENTS,
  SERVER_ERROR,
  SETTINGS,
  WITHDRAWAL,
  UPBALANCE,
  MERCHANT_APPLICATIONS,
  MERCHANT_SETTLEMENTS,
  MERCHANT_DISPUTES,
  MERCHANT_OVERVIEW,
} from './utils/constants/routes';
import { useRecoilState } from 'recoil';
import { defaultIsMobile } from './utils/states/isMobile.state';
import { AccountSettings } from './pages/Trader/AccountSettings/AccountSettings';
import { Cards } from './pages/Trader/Cards/page/Cards';
import { Orders } from './pages/Trader/OrdersAndWithdrawals/Orders/page/Orders';
import { Applications } from './pages/Trader/OrdersAndWithdrawals/Applications/page/Applications';
import { Settlements } from './pages/Trader/OrdersAndWithdrawals/Settlements/page/Settlements';
import { Disputes } from './pages/Trader/OrdersAndWithdrawals/Disputes/page/Disputes';
import Withdrawal from './pages/Trader/OrdersAndWithdrawals/Withdrawals/page/Withdrawal';
import UpBalance from 'pages/UpBalance';
export const App = () => {
  const [version, setVersion] = useRecoilState(defaultIsMobile);
  useEffect(() => {
    const handleResize = () => {
      setVersion({ isMobile: window.innerWidth <= 1024 });
    };
    handleResize();
    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  return (
    <Router>
      <div className='App' style={{ height: '100%' }}>
        <Routes>
          <Route path={'*'} element={<NotFoundError />} />
          <Route path={UPBALANCE} element={<UpBalance />} />
          <Route path={SERVER_ERROR} element={<ServerError />} />
          <Route path={FORBIDDEN_ERROR} element={<ForbiddenError />} />
          <Route path={AUTH} element={<Auth />} />
          <Route path={''} element={<ProtectedRouter />}>
            <Route path={CARDS} element={<Cards />} />
            <Route path={APPLICATIONS} element={<Orders />} />
            <Route path="/merchant" element={<Navigate to={MERCHANT_APPLICATIONS} replace />} />
            <Route path={MERCHANT_OVERVIEW} element={<Navigate to={MERCHANT_APPLICATIONS} replace />} />
            <Route path={MERCHANT_APPLICATIONS} element={<Applications />} />
            <Route path={MERCHANT_SETTLEMENTS} element={<Settlements />} />
            <Route path={MERCHANT_DISPUTES} element={<Disputes />} />
            <Route path={WITHDRAWAL} element={<Withdrawal />} />
            <Route path={PAYMENTS} element={<Payments />} />
            <Route path={SETTINGS} element={<AccountSettings />} />
          </Route>
        </Routes>
      </div>
    </Router>
  );
};
